import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class MedicalFileService {
  
  constructor(private http: HttpClient) {
  }
 
  saveCarePlan(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/master/medicalCarePlan/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getCarePlans(medFileId): Observable<any> {
    let url='api/master/medicalCarePlans';
    if(medFileId){
      url=url+'?medFileId='+medFileId;
    }
    return this.http.get(CommonConstants.env +url).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getCarePlanTypesById(planId){
    return this.http.get(CommonConstants.env +'api/master/medicalCarePlans?planId='+planId).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getCarePlanTypes(): Observable<any> {
    return this.http.get(CommonConstants.env +'api/master/carePlanTypes').
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveMedFiles(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/medicalFile/', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveDiagnostics(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/diagnostics', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveMedication(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/medication', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  savePersonals(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/personnals', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

 getMedFiles(fileId): Observable<any> {
    return this.http.get(CommonConstants.env +'api/medicalFile/details/'+fileId).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  loadPartnersForCaseReview(){
    return this.http.get(CommonConstants.env +'api/medicalFile/practinersAndHospitals').
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getMedicalFile(fileId){
    return this.http.get(CommonConstants.env +'api/medicalFile/file/'+fileId).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveExaminations(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/examination', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  searchSnomed(searchdata: any) {
    return this.http.post(CommonConstants.env +'api/snomed/search', searchdata).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getDetailsByKeys(fileId,serviceKeys): Observable<any> {
    return this.http.get(CommonConstants.GET_DETAILS_BY_SERVICE_KEY+fileId+'?services='+serviceKeys).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveProgress(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/progress', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveProcedure(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/procedure', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveSplTreatment(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/special/treatment', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getMedicalFilesByKey(id, keys): Observable<any> {
    return this.http.get(CommonConstants.env +'api/medicalFile/'+id+"?services="+keys).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  searchMedicalFiles(obj: any): Observable<any> {
    return this.http.post(CommonConstants.env + 'api/medicalFile/search', obj);
  }

  saveAskTransfer(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/transfer', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAssistance(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/assistance', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveTransferConditions(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/transferCondition', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  savePreferredLocation(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/preferred/location', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAllergies(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/allergy', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  errorHandler(error: any): void {
    throwError(error);
  };

  savePatientHistory(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/patient/history', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveSecondOpinion(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/second/opinion', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveFamilyHistory(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/family/history', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveFamilyAtcd(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/family/atcd', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveImmediateAction(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/immediate/action', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveObjectiveSign(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/objectivesign', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveSubjectiveSign(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/subjectivesign', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveCaseReviewAddPract(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/casereview/practioner/add', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveCaseReviewAddHosp(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/casereview/hospital/add', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveQuestions(saveData){
    return this.http.post(CommonConstants.env +'questions/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveComments(saveData){
    return this.http.post(CommonConstants.env +'qn/comment/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveAffectations(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/casereview/affectation/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getComments(questionId): Observable<any> {
    return this.http.get(CommonConstants.env +'qn/comment/'+questionId).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveMedDocRetrieve(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/document/retreive', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  } 
  saveMedServicePlan(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/medical/service/plan', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveMedLogisticServicePlan(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/medical/logistic/plan', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveMedVisits(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/medical/visit', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveMedNeeds(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/medical/need', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveDischarge(saveData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/discharge', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAdminPatientTransfer(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/admin/patient/transfer', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAdminCompanion(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/admin/companion', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAdminFollowUp(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/admin/followup', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveLogPatientWise(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/patientwise', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveLogisticPackage(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/patient/package', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAccompanionPackage(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/patient/accompanion/package', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  
  saveLogisticPatient(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/patient', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  savePatientAccomadation(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/patient/accomodation', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveLogisticFollowupOther(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/followup/other', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveLogisticFollowupTransport(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/followup/transport', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveLogisticFollowupAccomadation(saveData){
    return this.http.post(CommonConstants.env +'api/medicalFile/logistic/followup/accomodation', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  updateFileStatus(jsonData) {
    return this.http.post(CommonConstants.env +'api/medicalFile/status/update', jsonData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
}
